<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="row">

                    <div class="col-md-12">
                        <app-sub-header title="Events"></app-sub-header>

                        <div class="margin-b" style="text-align: end;">
                            <button routerLink='/event-manager/create-event'
                                class="btn main-backgroundcolor color">Create
                                event</button>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">

                        <app-no-results-found *ngIf="eventArr?.length == 0 && loading" title='Events'>
                        </app-no-results-found>
                        <div class="col-md-12" *ngIf="!loading">

                            <div *ngFor="let props of arr">
                                <app-card-skelton title='Events'></app-card-skelton>
                            </div>
                        </div>


                        <div class="col-md-12" *ngIf="loading">
                            <div *ngFor="let props of (objArr | paginate
                        : {
                            itemsPerPage: pageSize,
                            currentPage: pageNo,
                            totalItems: totalItems
                          })">
                                <app-events [showheader]=false [data]="props"></app-events>
                            </div>
                        </div>
                        <div *ngIf="objArr.length > 5" class="col-md-12" style="text-align: center;">
                            <pagination-controls class="col s12 col-md-offset-3 my-pagination"
                                *ngIf="objArr?.length > 0 " (pageChange)="page = getAlerts($event)"
                                directionLinks="true" autoHide="false" responsive="true" previousLabel="Previous"
                                nextLabel="Next" screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                                screenReaderCurrentLabel="You're on page">
                            </pagination-controls>
                        </div>
                    </div>
                </div>



            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>

<router-outlet></router-outlet>